// import React, { useEffect, useState } from "react";
// import {
//   Modal,
//   ModalBody,
//   ModalFooter,
//   ModalHeader,
//   Row,
//   Col,
// } from "reactstrap";
// import {
//   createProductTypeWithOutHUID,
//   getProducts,
//   getProductTypeWithOutHUIDs,
// } from "../../../helpers/urlConfig/apiFunctions";
// import {
//   errorToastify,
//   successToastify,
// } from "../../../Components/Common/Toaster";
// import { getSessionData } from "../../../helpers/sessionDetailsParser";
// import errorResponseHandler from "../../../helpers/errorResponseHandler";

// function ProductTypeWithOutHUIDCreate({
//   pt_wo_huid_modal_list,
//   set_pt_wo_huid_modal_list,
//   pt_wo_huid_tog_list,
//   fetchData,
//   modelData,
// }) {
//   const [productName, setProductName] = useState([]);
//   const [productTypeNames, setProductTypeName] = useState([]);
//   const [modelNames, setModelName] = useState([]);

//   const [productData, setProductData] = useState([
//     {
//       product_name: "",
//       product_type_name: "",
//       gram: "",
//       //   gender: "",
//       //   age: "",
//       stock: 1,
//       model_name: "",
//       created_by: getSessionData("user_id"),
//     },
//   ]);

//   const handleInputChange = (index, field, value) => {
//     const newProductData = [...productData];
//     newProductData[index][field] = value;
//     setProductData(newProductData);
//   };

//   const addNewRow = () => {
//     if (productData.length < 10) {
//       setProductData([
//         ...productData,
//         {
//           product_name: "",
//           product_type_name: "",
//           gram: "",
//           stock: 1,
//           model_name: "",
//           created_by: getSessionData("user_id"),
//         },
//       ]);
//     }
//   };

//   const removeRow = (index) => {
//     const newProductData = productData.filter((_, i) => i !== index);
//     setProductData(newProductData);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Create a copy of productData and assign 0 to empty gram and stock fields
//     const updatedProductData = productData.map((item) => ({
//       ...item,
//       gram: item.gram === "" ? "0" : item.gram,
//       stock: item.stock === "" ? 0 : item.stock,
//     }));

//     const response = await createProductTypeWithOutHUID(updatedProductData);
//     console.log("without huid create response", response);

//     if (response.statusCode === 200 && response.success.length > 0) {
//       successToastify("Stocks With Out HUID Created Successfully");
//       fetchData();
//       set_pt_wo_huid_modal_list(false); //  Close modal after submission
//     } else {
//       if (response.failed.length > 0) {
//         if (response.failed[0].error.code === "ER_DUP_ENTRY") {
//           errorToastify(response.failed[0].error.sqlMessage);
//         }
//       }
//     }
//   };

//   const getProductData = async () => {
//     try {
//       const response = await getProducts();
//       if (response.statusCode === 200) {
//         setProductName(response.data);
//       } else {
//         errorResponseHandler(response);
//       }
//     } catch (error) {
//       console.error(error.message);
//     }
//   };

//   const getProductTypeData = async () => {
//     try {
//       const response = await getProductTypeWithOutHUIDs({ model_name: null });

//       if (response.statusCode === 200) {
//         // Extract unique product type names using a Set
//         const productTypeNames = [
//           ...new Set(response.data.map((item) => item.product_type_name)),
//         ];

//         const modelNames = [
//           ...new Set(response.data.map((item) => item.model_name)),
//         ];

//         setProductTypeName(productTypeNames);
//         setModelName(modelNames);
//       } else {
//         console.error("with huid", response);
//         errorResponseHandler(response);
//       }
//     } catch (error) {
//       console.error(error.message);
//     }
//   };

//   useEffect(() => {
//     getProductData();
//     getProductTypeData();
//   }, []);

//   return (
//     <Modal
//       size="xl"
//       isOpen={pt_wo_huid_modal_list}
//       toggle={pt_wo_huid_tog_list}
//       className="modal-fullscreen"
//       id="fullscreeexampleModal"
//     >
//       <ModalHeader
//         className="modal-title"
//         id="fullscreeexampleModalLabel"
//         toggle={pt_wo_huid_tog_list}
//       >
//         Add Product Types With Out HUID
//       </ModalHeader>
//       <form className="tablelist-form" onSubmit={handleSubmit}>
//         <ModalBody className="bg-light">
//           {productData.map((data, index) => (
//             <div
//               key={index}
//               className="border bg-white p-4 mb-4 rounded shadow-sm"
//             >
//               <h6 className="mb-3">Entry {index + 1}</h6>
//               <Row className="gy-3 align-items-center">
//                 <Col md={2}>
//                   <label
//                     htmlFor={`product_name-${index}`}
//                     className="form-label"
//                   >
//                     Product Name
//                   </label>
//                   <select
//                     className="form-control"
//                     id={`product_name-${index}`}
//                     value={data.product_name} // Use the correct state key
//                     onChange={
//                       (e) =>
//                         handleInputChange(index, "product_name", e.target.value) // Pass the correct key
//                     }
//                     required
//                   >
//                     <option value="">Select</option>
//                     {productName.length > 0 &&
//                       productName.map((item, index) => (
//                         <option key={index} value={item.product_name}>
//                           {item.product_name}
//                         </option>
//                       ))}
//                   </select>
//                 </Col>

//                 {/* <Col md={2}>
//                   <label
//                     htmlFor={`product_type_name-${index}`}
//                     className="form-label"
//                   >
//                     Product Type Name
//                   </label>
//                   <input
//                     type="text"
//                     id={`product_type_name-${index}`}
//                     className="form-control"
//                     placeholder="Enter Product Type Name"
//                     value={data.product_type_name}
//                     onChange={(e) =>
//                       handleInputChange(
//                         index,
//                         "product_type_name",
//                         e.target.value
//                       )
//                     }
//                     required
//                   />
//                 </Col> */}
//                 <Col md={2}>
//                   <label
//                     htmlFor={`product_type_name-${index}`}
//                     className="form-label"
//                   >
//                     Product Type Name
//                   </label>
//                   <select
//                     className="form-control"
//                     id={`product_type_name-${index}`}
//                     value={
//                       productTypeNames.includes(data.product_type_name)
//                         ? data.product_type_name
//                         : "New"
//                     }
//                     onChange={(e) => {
//                       if (e.target.value !== "New") {
//                         handleInputChange(
//                           index,
//                           "product_type_name",
//                           e.target.value
//                         );
//                       } else {
//                         handleInputChange(index, "product_type_name", "");
//                       }
//                     }}
//                     required
//                   >
//                     <option value="">Select</option>
//                     {productTypeNames.map((type, idx) => (
//                       <option key={idx} value={type}>
//                         {type}
//                       </option>
//                     ))}
//                     <option value="New">+ New</option>
//                   </select>
//                   {(!data.product_type_name ||
//                     !productTypeNames.includes(data.product_type_name)) && (
//                     <input
//                       type="text"
//                       className="form-control mt-2"
//                       placeholder="Enter new product type"
//                       value={data.product_type_name}
//                       onChange={(e) =>
//                         handleInputChange(
//                           index,
//                           "product_type_name",
//                           e.target.value
//                         )
//                       }
//                       required
//                     />
//                   )}
//                 </Col>

//                 {/* <Col md={2}>
//                   <label htmlFor={`model-${index}`} className="form-label">
//                     Model Name
//                   </label>
//                   <input
//                     type="text"
//                     id={`model-${index}`}
//                     className="form-control"
//                     placeholder="Enter Model Name"
//                     value={data.model_name}
//                     onChange={(e) =>
//                       handleInputChange(
//                         index,
//                         "model_name",
//                         e.target.value.toUpperCase()
//                       )
//                     }
//                     required
//                   />
//                 </Col> */}
//                 <Col md={2}>
//                   <label htmlFor={`model_name-${index}`} className="form-label">
//                     Model Name
//                   </label>
//                   <select
//                     className="form-control"
//                     id={`model_name-${index}`}
//                     value={
//                       modelNames.includes(data.model_name)
//                         ? data.model_name
//                         : "New"
//                     }
//                     onChange={(e) => {
//                       if (e.target.value !== "New") {
//                         handleInputChange(index, "model_name", e.target.value);
//                       } else {
//                         handleInputChange(index, "model_name", "");
//                       }
//                     }}
//                     required
//                   >
//                     <option value="">Select</option>
//                     {modelNames.map((type, idx) => (
//                       <option key={idx} value={type}>
//                         {type}
//                       </option>
//                     ))}
//                     <option value="New">+ New</option>
//                   </select>
//                   {(!data.model_name ||
//                     !modelNames.includes(data.model_name)) && (
//                     <input
//                       type="text"
//                       className="form-control mt-2"
//                       placeholder="Enter new modal name"
//                       value={data.model_name}
//                       onChange={(e) =>
//                         handleInputChange(
//                           index,
//                           "model_name",
//                           e.target.value.toUpperCase()
//                         )
//                       }
//                       required
//                     />
//                   )}
//                 </Col>

//                 <Col md={2}>
//                   <label htmlFor={`Gram-${index}`} className="form-label">
//                     Gram
//                   </label>
//                   <input
//                     type="text"
//                     id={`Gram-${index}`}
//                     className="form-control"
//                     placeholder="Enter Grams"
//                     value={data.gram}
//                     onChange={(e) =>
//                       handleInputChange(index, "gram", e.target.value)
//                     }
//                     required
//                   />
//                 </Col>

//                 {/* <Col md={2}>
//                   <label htmlFor={`gender-${index}`} className="form-label">
//                     Gender
//                   </label>
//                   <select
//                     className="form-control"
//                     id={`gender-${index}`}
//                     value={data.gender || "-"}
//                     onChange={(e) =>
//                       handleInputChange(index, "gender", e.target.value)
//                     }
//                   >
//                     <option value="">Select</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                   </select>
//                 </Col> */}

//                 {/* <Col md={2}>
//                   <label htmlFor={`age-${index}`} className="form-label">
//                     Age
//                   </label>
//                   <input
//                     type="number"
//                     id={`age-${index}`}
//                     className="form-control"
//                     placeholder="Enter Age"
//                     value={data.age || "-"}
//                     onChange={(e) =>
//                       handleInputChange(index, "age", e.target.value)
//                     }
//                   />
//                 </Col> */}

//                 <Col md={2}>
//                   <label htmlFor={`stock-${index}`} className="form-label">
//                     Quantity
//                   </label>
//                   <input
//                     type="number"
//                     id={`stock-${index}`}
//                     className="form-control"
//                     placeholder="Enter Stock"
//                     value={data.stock}
//                     onChange={(e) =>
//                       handleInputChange(index, "stock", e.target.value)
//                     }
//                     required
//                   />
//                 </Col>
//               </Row>

//               {productData.length > 1 && (
//                 <div className="mt-2">
//                   <button
//                     type="button"
//                     className="btn btn-danger btn-sm"
//                     onClick={() => removeRow(index)}
//                   >
//                     Remove Entry
//                   </button>
//                 </div>
//               )}
//             </div>
//           ))}

//           {productData.length < 10 && (
//             <button
//               type="button"
//               className="btn btn-primary btn-sm mt-3"
//               onClick={addNewRow}
//             >
//               Add More
//             </button>
//           )}
//         </ModalBody>
//         <ModalFooter>
//           <div className="hstack gap-2 justify-content-end">
//             <button
//               type="button"
//               className="btn btn-light"
//               onClick={() => set_pt_wo_huid_modal_list(false)}
//             >
//               Close
//             </button>
//             <button type="submit" className="btn btn-success">
//               Add Product Type
//             </button>
//           </div>
//         </ModalFooter>
//       </form>
//     </Modal>
//   );
// }

// export default ProductTypeWithOutHUIDCreate;

import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
} from "reactstrap";
import {
  createProductTypeWithOutHUID,
  createProductTypeWithOutHUIDTransactions,
  getProducts,
  getProductTypeWithOutHUIDs,
} from "../../../helpers/urlConfig/apiFunctions";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function ProductTypeWithOutHUIDCreate({
  pt_wo_huid_modal_list,
  set_pt_wo_huid_modal_list,
  pt_wo_huid_tog_list,
  fetchData,
  modelData,
}) {
  const [productName, setProductName] = useState([]);
  const [productTypeNames, setProductTypeName] = useState([]);
  const [modelNames, setModelName] = useState([]);

  // Initialize productData with modelData values if available
  const [productData, setProductData] = useState([
    {
      product_name: modelData?.product_name || "",
      product_type_name: modelData?.product_type_name || "",
      gram: "",
      stock: "",
      model_name: modelData?.model_name || "",
      created_by: getSessionData("user_id"),
    },
  ]);

  const handleInputChange = (index, field, value) => {
    const newProductData = [...productData];
    newProductData[index][field] = value;
    setProductData(newProductData);
  };

  const addNewRow = () => {
    if (productData.length < 10) {
      setProductData([
        ...productData,
        {
          product_name: modelData?.product_name || "",
          product_type_name: modelData?.product_type_name || "",
          gram: "",
          stock: 1,
          model_name: modelData?.model_name || "",
          created_by: getSessionData("user_id"),
        },
      ]);
    }
  };

  const removeRow = (index) => {
    const newProductData = productData.filter((_, i) => i !== index);
    setProductData(newProductData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a copy of productData and assign 0 to empty gram and stock fields
    const updatedProductData = productData.map((item) => ({
      ...item,
      gram: item.gram === "" ? "0" : item.gram,
      stock: item.stock === "" ? 0 : item.stock,
    }));

    try {
      let response;
      if (modelData?.product_name) {
        response = await createProductTypeWithOutHUIDTransactions(
          updatedProductData
        );
      } else {
        response = await createProductTypeWithOutHUID(updatedProductData);
      }

      console.log("without huid create response", response);

      if (response.statusCode === 200 && response.success.length > 0) {
        successToastify("Stocks With Out HUID Created Successfully");
        fetchData();
        set_pt_wo_huid_modal_list(false); // Close modal after submission
      } else {
        if (response.failed.length > 0) {
          if (response.failed[0].error.code === "ER_DUP_ENTRY") {
            errorToastify(response.failed[0].error.sqlMessage);
          }
        }
      }
    } catch (error) {
      console.error("Error submitting product data:", error);
      errorToastify("Failed to create product type");
    }
  };

  const getProductData = async () => {
    try {
      const response = await getProducts();
      if (response.statusCode === 200) {
        setProductName(response.data);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const getProductTypeData = async () => {
    try {
      const response = await getProductTypeWithOutHUIDs({ model_name: null });

      if (response.statusCode === 200) {
        // Extract unique product type names using a Set
        const productTypeNames = [
          ...new Set(response.data.map((item) => item.product_type_name)),
        ];

        const modelNames = [
          ...new Set(response.data.map((item) => item.model_name)),
        ];

        setProductTypeName(productTypeNames);
        setModelName(modelNames);
      } else {
        console.error("with huid", response);
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    getProductData();
    getProductTypeData();
  }, []);

  return (
    <Modal
      size="xl"
      isOpen={pt_wo_huid_modal_list}
      toggle={pt_wo_huid_tog_list}
      className="modal-fullscreen"
      id="fullscreeexampleModal"
    >
      <ModalHeader
        className="modal-title"
        id="fullscreeexampleModalLabel"
        toggle={pt_wo_huid_tog_list}
      >
        Add Product Types With Out HUID
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit}>
        <ModalBody className="bg-light">
          {productData.map((data, index) => (
            <div
              key={index}
              className="border bg-white p-4 mb-4 rounded shadow-sm"
            >
              <h6 className="mb-3">Entry {index + 1}</h6>
              <Row className="gy-3 align-items-center">
                <Col md={2}>
                  <label
                    htmlFor={`product_name-${index}`}
                    className="form-label"
                  >
                    Product Name
                  </label>
                  <select
                    className="form-control"
                    id={`product_name-${index}`}
                    value={data.product_name}
                    onChange={(e) =>
                      handleInputChange(index, "product_name", e.target.value)
                    }
                    required
                    disabled={!!modelData?.product_name} // Disable if modelData.product_name exists
                  >
                    <option value="">Select</option>
                    {productName.length > 0 &&
                      productName.map((item, idx) => (
                        <option key={idx} value={item.product_name}>
                          {item.product_name}
                        </option>
                      ))}
                  </select>
                </Col>

                <Col md={2}>
                  <label
                    htmlFor={`product_type_name-${index}`}
                    className="form-label"
                  >
                    Product Type Name
                  </label>
                  <select
                    className="form-control"
                    id={`product_type_name-${index}`}
                    value={
                      productTypeNames.includes(data.product_type_name)
                        ? data.product_type_name
                        : "New"
                    }
                    onChange={(e) => {
                      if (e.target.value !== "New") {
                        handleInputChange(
                          index,
                          "product_type_name",
                          e.target.value
                        );
                      } else {
                        handleInputChange(index, "product_type_name", "");
                      }
                    }}
                    required
                    disabled={!!modelData?.product_type_name} // Disable if modelData.product_name exists
                  >
                    <option value="">Select</option>
                    {productTypeNames.map((type, idx) => (
                      <option key={idx} value={type}>
                        {type}
                      </option>
                    ))}
                    <option value="New">+ New</option>
                  </select>
                  {(!data.product_type_name ||
                    !productTypeNames.includes(data.product_type_name)) && (
                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Enter new product type"
                      value={data.product_type_name}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "product_type_name",
                          e.target.value
                        )
                      }
                      required
                    />
                  )}
                </Col>

                <Col md={2}>
                  <label htmlFor={`model_name-${index}`} className="form-label">
                    Model Name
                  </label>
                  <select
                    className="form-control"
                    id={`model_name-${index}`}
                    value={
                      modelNames.includes(data.model_name)
                        ? data.model_name
                        : "New"
                    }
                    onChange={(e) => {
                      if (e.target.value !== "New") {
                        handleInputChange(index, "model_name", e.target.value);
                      } else {
                        handleInputChange(index, "model_name", "");
                      }
                    }}
                    required
                    disabled={!!modelData?.model_name} // Disable if modelData.product_name exists
                  >
                    <option value="">Select</option>
                    {modelNames.map((type, idx) => (
                      <option key={idx} value={type}>
                        {type}
                      </option>
                    ))}
                    <option value="New">+ New</option>
                  </select>
                  {(!data.model_name ||
                    !modelNames.includes(data.model_name)) && (
                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Enter new model name"
                      value={data.model_name}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "model_name",
                          e.target.value.toUpperCase()
                        )
                      }
                      required
                    />
                  )}
                </Col>

                <Col md={2}>
                  <label htmlFor={`Gram-${index}`} className="form-label">
                    Gram
                  </label>
                  <input
                    type="text"
                    id={`Gram-${index}`}
                    className="form-control"
                    placeholder="Enter Grams"
                    value={data.gram}
                    onChange={(e) =>
                      handleInputChange(index, "gram", e.target.value)
                    }
                    required
                    disabled={!modelData?.product_name}
                  />
                </Col>

                <Col md={2}>
                  <label htmlFor={`stock-${index}`} className="form-label">
                    Quantity
                  </label>
                  <input
                    type="number"
                    id={`stock-${index}`}
                    className="form-control"
                    placeholder="Enter Stock"
                    value={data.stock}
                    onChange={(e) =>
                      handleInputChange(index, "stock", e.target.value)
                    }
                    required
                    disabled={!modelData?.product_name}
                  />
                </Col>
              </Row>

              {productData.length > 1 && (
                <div className="mt-2">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeRow(index)}
                  >
                    Remove Entry
                  </button>
                </div>
              )}
            </div>
          ))}

          {productData.length < 10 && (
            <button
              type="button"
              className="btn btn-primary btn-sm mt-3"
              onClick={addNewRow}
            >
              Add More
            </button>
          )}
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => set_pt_wo_huid_modal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success">
              Add Product Type
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default ProductTypeWithOutHUIDCreate;
